import type { RootState } from '..';

export const selectUtilityCompanies = (state: RootState) =>
  state.utilityCompany.utilityCompanies;
